// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3kK7F","newExpiryDate":"styles_newExpiryDate__2iI8k","footer":"styles_footer__2rUK6"};